import React, { useState } from 'react';

import { handleLogin } from 'legacy/auth/helpers';
import Wrapper from 'legacy/common/components/layout/BackgroundWrapper';

import SignUpForm from 'legacy/auth/components/signup/SignUpForm';
import SignUpConfirmation from 'legacy/auth/components/signup/SignUpConfirmation';

import {
  useConfirmSignupVerificationSessionCommand,
  useCreateSignupVerificationSessionCommand
} from 'legacy/auth/hooks';

const SignUp = () => {
  const [password, setPassword] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [callingCode, setCallingCode] = useState<string>();
  const [verificationSessionId, setVerificationSessionId] = useState<string>();

  const createSignUpVerificationSessionCommand =
    useCreateSignupVerificationSessionCommand();

  const confirmSignupVerificationSessionCommand =
    useConfirmSignupVerificationSessionCommand();

  const handleSignUp = ({
    password,
    phoneNumber,
    callingCode,
    email
  }) => {
    if (phoneNumber) {
      if (phoneNumber.startsWith(callingCode)) {
        phoneNumber = phoneNumber.slice(callingCode.length);
      }
      createSignUpVerificationSessionCommand.mutate(
        {
          phone: phoneNumber,
          countryCode: callingCode,
          email
        },
        {
          onSuccess: (data) => {
            setPassword(password);
            setPhoneNumber(phoneNumber);
            setCallingCode(callingCode);
            setVerificationSessionId(data.verificationSessionId);
          }
        }
      );
    } else {
      createSignUpVerificationSessionCommand.mutate(
        {
          email
        },
        {
          onSuccess: (data) => {
            confirmSignupVerificationSessionCommand.mutate(
              {
                verificationSessionId: data.verificationSessionId,
                password
              },
              {
                onSuccess: (confirmData) => {
                  handleLogin(confirmData);
                }
              }
            );
          }
        }
      );
    }
  };

  const handleConfirmSignUp = (code: string) => {
    confirmSignupVerificationSessionCommand.mutate(
      {
        password,
        smsCode: code,
        verificationSessionId
      },
      {
        onSuccess: (data) => {
          handleLogin(data);
        }
      }
    );
  };

  const handleResendCode = () => {
    createSignUpVerificationSessionCommand.mutate({
      phone: phoneNumber,
      countryCode: callingCode
    });
  };

  const onReset = () => {
    setPassword(null);
    setPhoneNumber(null);
    setVerificationSessionId(null);
    createSignUpVerificationSessionCommand.reset();
  };

  if (verificationSessionId) {
    return (
      <Wrapper>
        <SignUpConfirmation
          onBackClick={onReset}
          onSubmit={handleConfirmSignUp}
          onResendCode={handleResendCode}
          isResendingCode={createSignUpVerificationSessionCommand.isLoading}
          isLoading={confirmSignupVerificationSessionCommand.isLoading}
          errorMessage={confirmSignupVerificationSessionCommand.error?.message}
        />
      </Wrapper>
    );
  }

  const isLoading =
    createSignUpVerificationSessionCommand.isLoading ||
    confirmSignupVerificationSessionCommand.isLoading;
  const errorMessage =
    createSignUpVerificationSessionCommand.error?.message ||
    confirmSignupVerificationSessionCommand.error?.message;

  return (
    <Wrapper>
      <SignUpForm
        onSubmit={handleSignUp}
        isLoading={isLoading}
        errorMessage={errorMessage}
      />
    </Wrapper>
  );
};

export default SignUp;
